import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getLatestFXRates } from '@dealstack/frontend/shared/dataExchange/services/valuations.service';
import { CurrencyType } from '@dealstack/shared/lib/generated';

export function useLatestFXRatesQuery(
	defaultCurrency: CurrencyType | undefined,
	currencies: ReadonlyArray<CurrencyType>
) {
	const query = useQuery({
		queryKey: ['fx-rates-latest', defaultCurrency ?? '', currencies],
		queryFn: () => getLatestFXRates({ baseCurrency: defaultCurrency ?? 'EUR', currencies }),
		enabled: !!defaultCurrency && currencies.length > 0,
	});

	const latestFxRates = useMemo(() => {
		const rates = query.data?.payload?.rates ?? [];
		return rates.reduce(
			(acc, rate) => {
				if (rate.value) {
					acc[rate.currency] = rate.value;
				}
				return acc;
			},
			{} as Partial<Record<CurrencyType, number>>
		);
	}, [query.data?.payload?.rates]);

	return {
		latestFxRates,
		isLatestFxRatesFetching: query.isFetching,
		refetchLatestFXRates: query.refetch,
	};
}
